import type {
  CloneTurnResponse,
  WbAgentClient,
} from '@wandb/weave/lib/WbAgent/WbAgentClient';

export type CloneThreadResult = CloneTurnResponse;

export type CloneThreadParams = {
  client: WbAgentClient;
  sourceTurnId: string;
};

/**
 * cloneThread copies the source turn's server-owned conversation prefix into a
 * new ordinary thread. The caller owns navigation to the returned thread.
 */
export function cloneThread({
  client,
  sourceTurnId,
}: CloneThreadParams): Promise<CloneThreadResult> {
  return client.post<CloneThreadResult>(`/turns/${sourceTurnId}/clone`);
}
